import { render, staticRenderFns } from "./DmsRolesPermissions.vue?vue&type=template&id=03a2023a"
import script from "./DmsRolesPermissions.vue?vue&type=script&lang=js"
export * from "./DmsRolesPermissions.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports